import { IPublicAuth } from '@state/auth/types'
import * as oidc from 'oidc-client'

export const DEFAULT_DEALER_ORGANIZATION = "User";
export const ORGANIZATION_DAFAULT_VALUE = "None";

export const getUserManager = () => {
    if (!(window as any)._userManager) {
        (window as any)._userManager = new oidc.UserManager({
            authority: process.env.REACT_APP_DS_IGNITION_AUTHORITY,
            client_id: process.env.REACT_APP_DS_IGNITION_CLIENT_ID,            
            redirect_uri: window.location.protocol + "//" + window.location.host + "/",
            silent_redirect_uri: window.location.protocol + "//" + window.location.host + "/",
            automaticSilentRenew: true,
            response_type: 'id_token token',
            scope: process.env.REACT_APP_DS_IGNITION_SCOPE,
            loadUserInfo: true,
            post_logout_redirect_uri: window.location.protocol + "//" + window.location.host + "/" // "http://localhost:3000/signin",
            
        })
    }
    return (window as any)._userManager
}

export const getPublicPath = (location: any, publicAuth: IPublicAuth) => {
    let url = "";
    publicAuth.authorizedPaths.map(authorizedPath => {
        if (authorizedPath.search(publicAuth.entityType)) {
            url = `${authorizedPath}${publicAuth.entityId}`;
        }
    })
    return url; 
}

export const getDealerOrganizationsArray = (organizations: string | string[]) => {
    if (!organizations) return [];
    if (typeof(organizations) === "string") return [organizations];
    else return organizations;
}


